/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateContentTagRequest
 */
export interface CreateContentTagRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateContentTagRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContentTagRequest
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContentTagRequest
     */
    organizationId: string;
}

/**
 * Check if a given object implements the CreateContentTagRequest interface.
 */
export function instanceOfCreateContentTagRequest(value: object): value is CreateContentTagRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    return true;
}

export function CreateContentTagRequestFromJSON(json: any): CreateContentTagRequest {
    return CreateContentTagRequestFromJSONTyped(json, false);
}

export function CreateContentTagRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateContentTagRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'color': json['color'] == null ? undefined : json['color'],
        'organizationId': json['organizationId'],
    };
}

export function CreateContentTagRequestToJSON(json: any): CreateContentTagRequest {
    return CreateContentTagRequestToJSONTyped(json, false);
}

export function CreateContentTagRequestToJSONTyped(value?: CreateContentTagRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'color': value['color'],
        'organizationId': value['organizationId'],
    };
}

